import { Tab, Tabs } from "@mui/material";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState, useRecoilValue } from "recoil";

import { useCrudEditContext } from "@ryde/redux";
import {
  dynamicFormTabIndexAF,
  INVISIBLE_FORM_TAB_LABEL,
  isInnerItemEditingAtom,
  removeSpaces,
  tabSF,
} from "@ryde/shared";

import { TabEarContainerStyled, TabPanelStyled } from "./edit-form.styled";

export const EditFormTabs: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();
  const { entity } = useCrudEditContext();

  const [tabIndex, setTabIndex] = useRecoilState(dynamicFormTabIndexAF(entity));
  const tabs = useRecoilValue(tabSF(entity));
  const isInnerItemEditing = useRecoilValue(isInnerItemEditingAtom);

  const handleTabChange = (
    _: React.SyntheticEvent,
    newTabIndex: string,
  ): void => {
    setTabIndex?.(+newTabIndex);
  };

  return (
    <>
      {!!(tabs?.length && tabs.length > 1) && (
        <TabEarContainerStyled
          className={clsx(isInnerItemEditing && "inner-item-editing")}
        >
          <Tabs
            variant="scrollable"
            value={tabIndex}
            onChange={handleTabChange}
            aria-label={`${entity} tabs`}
            scrollButtons
          >
            {tabs
              ?.filter(x => x.label !== INVISIBLE_FORM_TAB_LABEL)
              ?.map((tab, index) => {
                const tabName = t(
                  `selectListLabel.${removeSpaces(tab.label?.toLowerCase())}`,
                );
                return (
                  <Tab
                    data-e2e-id={`${tab.label}_${index}`}
                    key={`${tab.label}_${index}`}
                    label={tabName || `${t("general.TAB")}-${index + 1}`}
                    id={`${index}`}
                  />
                );
              })}
          </Tabs>
        </TabEarContainerStyled>
      )}
      <TabPanelStyled>{children}</TabPanelStyled>
    </>
  );
};
